import clsx from 'clsx'
import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

const WhyManuva = ({ ArrowIcon, dropdownOpen, setDropdownOpen }) => {
  return (
    <div className="relative">
      <Link
        to="/about-us"
        className="text-[#101838] text-sm xl:text-base leading-[150%]"
        // onClick={() => dropdownOpen !== 'why-manuva' ? setDropdownOpen('why-manuva') : setDropdownOpen('')}
      >
        About Us
      </Link>

      <div className={clsx(
        'bg-neutral-10 absolute w-[280px] rounded border-l-2 border-l-primary-main mt-9 z[1]',
        dropdownOpen === 'why-manuva' ? 'block' : 'hidden'
      )}>
        <Link
          to="/about-us"
          className="border-b border-b-neutral-30 hover:rounded hover:bg-[#F7F8FA] text-s-reguler text-neutral-100 py-2 px-4"
        >About Us</Link>
        <Link
          to="#"
          className="hover:rounded hover:bg-[#F7F8FA] text-s-reguler text-neutral-100 py-2 px-4"
        >How we work</Link>
      </div>
    </div>
  )
}

WhyManuva.propTypes = {
  ArrowIcon: PropTypes.node,
  dropdownOpen: PropTypes.string,
  setDropdownOpen: PropTypes.func
}

export default WhyManuva
